/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { Button } from '@insticator/insticator-ui'; // iui-material
// utils
import { isContentValid } from 'utils/embedcontentvalidation';



/* ========== ~~~~~~~~~~ CTA : NEW CONTENT ~~~~~~~~~~ ========== */
const NewContentCTA = (props) => {
	function handleClick(e) {
		e.preventDefault();
		if(isContentValid(props.selectedContent)) {
			props.addContent('quiz', props.placement);
			//props.updateNoLiveContent(false)
		} else {
            props.invalidateSelectedContent();
            props.sendMessage('There are required fields you must fill out before continuing.');
        }
	}
    return(
    	<Button type={`custom`} handleClick={handleClick} variant={`primary`} name={`newcontent`} text={`Add Card +`} disabled={props.disabled} />
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default NewContentCTA;
